import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { useShellContext } from "@insite/client-framework/Components/IsInShell";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getLink, getPageLinkByPageType, useGetLink, useGetLinks } from "@insite/client-framework/Store/Links/LinksSelectors";
import { HasFields } from "@insite/client-framework/Types/ContentItemModel";
import { LinkFieldValue } from "@insite/client-framework/Types/FieldDefinition";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import Clickable from "@insite/mobius/Clickable";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Icon from "@insite/mobius/Icon";
import Img from "@insite/mobius/Img";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import { useHistory } from "@insite/mobius/utilities/HistoryContext";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { COLORS, TYPOGRAPHY } from "@tCentro/theme/design";
import React, { FC, useState } from "react";
import { connect, ResolveThunks } from "react-redux";

import { css } from "styled-components";


interface OfferingModel {
    fields: {
        image: string;
        linkTitle: string;
        destination: LinkFieldValue;
    };
}

const enum fields {
    offerings = "offerings",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.offerings]: OfferingModel[];
    };
    extendedStyles?: OfferingStyles;
}

export interface OfferingStyles {
    container?: InjectableCss;
    callWrapper?: InjectableCss;
    helpWrapper?:InjectableCss;
    buttonLabel?: InjectableCss;
    gridWrapper?: GridContainerProps;
    gridItem?: GridItemProps;
}

export const offeringStyles: OfferingStyles = {
    gridWrapper: {
        css: css`
            flex-wrap: wrap;
            background: ${COLORS.border.light};
        `,
    },
    gridItem: {
        width: 6,
        css: css`
            align-items: center;
            padding: 0px 1px !important;
            flex-direction: column;
        `,
    },
    container: {
        css: css`
            background: ${COLORS.background.tag};
            height: 92px;
            display: flex;
            width: 100%
        `,
    },
    callWrapper: {
        css:css`
            width: 100%;
            display: flex;
            justify-content: center;
        `,
    },
    buttonLabel: {
        css:css`
            font-size: ${TYPOGRAPHY.size.base};
            font-weight: ${TYPOGRAPHY.weight.mediumbold};
            line-height: ${TYPOGRAPHY.lineHeight.base};
            &:focus {
                outline: none !important;
            }
            span {
            color: ${COLORS.white} !important;
            display: flex;
            flex-direction: column;
            text-align:center;
            img {
                margin: 0px 10px 8px;
            }
        `,
    }
};



const mapStateToProps = (state: ApplicationState, ownProps:OwnProps) => {
    return {
        pageLink1: ownProps.fields.offerings.map(card => getLink(state, card.fields.destination)),
        
    }
};

const mapDispatchToProps = {};
type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export const HelpSection: FC<Props>  = ({ fields, pageLink1, extendedStyles}) => {
    const history = useHistory();
    const [styles] = useState(() => mergeToNew(offeringStyles, extendedStyles));

    // const closeDrawer = () => {
    //     props.setNavDrawerIsOpen({ navDrawerIsOpen: false });
    //     setTimeout(() => props.setNavDrawerIsOpen({ navDrawerIsOpen: undefined }), 300);
    // };

    return (
        <GridContainer {...styles.gridWrapper}>
            {fields.offerings &&
                fields.offerings.length &&
                fields.offerings.map((offering, index) => (
                    
                    // eslint-disable-next-line react/no-array-index-key
                    <GridItem {...styles.gridItem} key={index}>
                        <StyledWrapper {...styles.container}>
                            <StyledWrapper {...styles.callWrapper}>
                <Link href={pageLink1[index]?.url} {...styles.buttonLabel}><Img src={offering.fields.image} altText={offering.fields.linkTitle} loading="lazy"/> {offering.fields.linkTitle}</Link>
                </StyledWrapper>
            </StyledWrapper>
                    </GridItem>
                    
                ))}
        </GridContainer>
    );
};

const helpSection: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(HelpSection),
    definition: {
        group: "Basic",
        displayName: "CEN Help Section",
        fieldDefinitions:[
            {
                name: fields.offerings,
                editorTemplate: "ListField",
                getDisplay: (item: HasFields) => {
                    return item.fields.name;
                },
                defaultValue: [],
                fieldType: "Translatable",
                fieldDefinitions: [
                    {
                        name: "image",
                        editorTemplate: "ImagePickerField",
                        defaultValue: "",
                    },
                    {
                        name: "linkTitle",
                        editorTemplate: "TextField",
                        defaultValue: "",
                    },
                    {
                        name: "destination",
                        editorTemplate: "LinkField",
                        defaultValue: { type: "Page", value: "" },
                    },
                ],
            },
        ]
    },
};

export default helpSection;
